import React, { useState } from 'react'
import LeftPanel from '../Element/LeftPanel'
import { profCasesPanelItems, profNotifyPanelItems } from 'Constants';


function SubTemplate({content, assistantScreen, activeTab, panelItems, activePanel, setActivePanel, leaveTabs}) {
    return (
      <div 
      className='w-full grid grid-cols-10 h-full  flex col-span-6 '
      >
        <div className='col-span-2 w-full min-h-[800px] sticky top-0 text-sm border border-r border-gray-200 border-l-0 border-t-0 border-b-0'>
        <LeftPanel activeTab={activeTab} panelItems={panelItems} activePanel={activePanel} setActivePanel={setActivePanel}/>
      </div>
      <div className='col-span-8'>
          {content}
        </div>
    </div>
  )
}

export default SubTemplate